import { ComponentType } from 'react';
import { Grid } from '@material-ui/core';
import { useRouteRef } from '@backstage/frontend-plugin-api';
import {
  RiCustomerService2Fill,
  RiCalendarEventFill,
  RiFileTextFill,
  RiFocus2Line,
} from '@remixicon/react';
import { parseEntityRef } from '@backstage/catalog-model';
import {
  LinkTags,
  viewTechDocRouteRef,
} from '@internal/backstage-plugin-hm-common';
import { LinkCard } from '../../../ui/card';

type QuickLinksT = {
  type: LinkTags;
  title: string;
  url: string;
  description: string;
  Icon: ComponentType<{ style?: React.CSSProperties }>;
};

const staticQuickLinks: QuickLinksT[] = [
  {
    type: LinkTags.BackstageCommunity,
    title: 'TechSpot Event Calendar',
    url: '/techspot-event-calendar',
    description: 'Events where we share, learn and connect.',
    Icon: RiCalendarEventFill,
  },
  {
    type: LinkTags.Support,
    title: 'Support',
    url: '/support',
    description: 'Get help and support for using Backstage.',
    Icon: RiCustomerService2Fill,
  },
  {
    type: LinkTags.Tooling,
    title: 'Tech Radar',
    url: '/tech-radar',
    description:
      'Tech Radar displays the state of technologies used within H&M.',
    Icon: RiFocus2Line,
  },
];

export const QuickLinks = () => {
  const viewTechdocLink = useRouteRef(viewTechDocRouteRef);

  const backstageTechDocsBase = viewTechdocLink
    ? viewTechdocLink(parseEntityRef('component:default/backstage'))
    : '/docs/default/component/backstage';

  const quickLinks: QuickLinksT[] = [
    {
      type: LinkTags.BackstageTechDocs,
      title: 'What is Backstage',
      url: `${backstageTechDocsBase}/overview/what-is-backstage`,
      description: "Learn about H&M's Internal Developer Portal",
      Icon: RiFileTextFill,
    },
    ...staticQuickLinks,
  ];

  return (
    <Grid container>
      {quickLinks.map(link => (
        <Grid item xs={6} key={link.title}>
          <LinkCard
            link={{
              ...link,
              name: link.title,
              description: link.description,
              link: link.url,
              tags: [link.type],
              icon: link.Icon,
            }}
            title={link.title}
            target="_self"
            fullHeight
          />
        </Grid>
      ))}
    </Grid>
  );
};
